
// eslint-disable-next-line import/no-named-as-default
import Swiper, { Scrollbar, Pagination } from 'swiper'
import LolePicture from '~/components/picture/lole-picture'
import LoleVideoPicture from '~/components/picture/lole-video-picture'
export default {
  components: { LolePicture, LoleVideoPicture },
  props: {
    product: {
      type: Object,
      required: true,
    },
    medias: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      videoOnError: false,
      slider: null,
      hovered: false,
    }
  },
  mounted() {
    this.slider = new Swiper(this.$refs.swiper, {
      modules: [Scrollbar, Pagination],
      slidesPerView: 1,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
        draggable: true,
      },
      speed: 500,
      allowTouchMove: true,
      preventClicks: true,
      preventClicksPropagation: true,
      watchSlidesVisibility: true,
    })
  },
  methods: {
    next() {
      this.slider.slideNext()
    },
    prev() {
      this.slider.slidePrev()
    },
  },
}
